import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/digital-ocean': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M87 481.8v-73.6h73.7v73.6h-73.7zM25.4 346.6h61.6v61.6h-61.6v-61.6zM491.6 176.9c53.2 170.3-73 327.1-235.6 327.1v-95.8h0.3v-0.3c101.7-0.2 180.5-101 141.4-208-14.3-39.6-46.1-71.4-85.8-85.7-107.1-38.8-208.1 39.9-208.1 141.7h-95.8c0-162.2 156.9-288.7 327-235.6 74.2 23.3 133.6 82.4 156.6 156.6zM256.3 407.9h-0.3v0.3h-95.3v-95.6h95.6v95.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/digital-ocean.js
// module id = 795
// module chunks = 0